import * as React from "react";
function XxlIcon() {
    return React.createElement("path", { d: "M21.0003 38.9999V25.6538L7.90039 9H40.1001L27.0002 25.6538V38.9999H21.0003Z", fill: "currentColor" });
}
export default XxlIcon;
//# sourceMappingURL=Xxl.js.map